<template>
  <div v-if="properties != null" class="drawer">
    <v-card v-if="open == true" transition="slide-y-transition" flat>
      <v-row justify="center" align="center" v-if="properties.children != null">
        <v-col v-for="(elem, id) in properties.children" :key="id" cols="12">
          <SubSection :component="elem" />
        </v-col>
      </v-row>
    </v-card>
    <div class="drawer-btn centered">
      <Button
        :title="open ? getCloseBtnText : getOpenBtnText"
        :icon="open ? 'up-circle' : 'down-circle'"
        @click.native="openDrawer()"
      >
      </Button>
    </div>
  </div>
</template>

<script>
import SubSection from "../Subsection";
// import { Icon } from "ant-design-vue";
import Button from "../SubComponents/Button";

export default {
  name: "Drawer",
  components: { SubSection, Button },
  data: () => {
    return {
      open: false
    };
  },
  props: {
    properties: {
      type: Object,
      default: null
    }
  },
  computed: {
    getCloseBtnText() {
      if (this.properties == null) return "Fermer";
      return this.properties.close_button
        ? this.properties.close_button
        : "Fermer";
    },
    getOpenBtnText() {
      if (this.properties == null) return "Ouvrir";
      return this.properties.open_button
        ? this.properties.open_button
        : "Ouvrir";
    }
  },
  methods: {
    openDrawer() {
      this.open = !this.open;
    }
  }
};
</script>

<style scoped>
.drawer {
  width: 100%;
  margin-bottom: 10px;
}
</style>
